export enum SortBy {
  Age = 'age',
  Name = 'name',
  Price = 'price',
}
